<template>
  <div class="update_info">
    <h1>WiBotic Firmware Update Download</h1>

    <p class="info-blurb" v-if="fw_response && fw_response.upgrade_options != ''">
      Download Transmitter Firmware, Web Firmware, and Charger Firmware from a single firmware
      version and upload them to the WiBotic transmitter that generated the link to this page.
    </p>

    <div class="fw_update_overall" v-if="fw_response">
      <div class="update-side">
        <h2>Current Firmware</h2>
        <div class="box img-bullet" id="current-firmware">
          <h3>{{fw_response.identified_firmware.name}}</h3>
          <ul>
            <li v-if="fw_response.identified_firmware.doc_link">
              <a :href="fw_response.identified_firmware.doc_link">Documentation</a>
            </li>
            <li v-if="fw_response.identified_firmware.api_link">
              <a :href="fw_response.identified_firmware.api_link">API Files</a>
            </li>
            <li v-if="fw_response.identified_firmware.changelog_link">
              <a :href="fw_response.identified_firmware.changelog_link">Changelog</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="between-box">
        <svg version="1.1" width=32 height=32 viewBox="0 0 32 32">
          <path d="m3.5 11.5v9h12v7l12-11.5-12-11.5v7z" stroke="#000"/>
        </svg>
      </div>
      <div class="update-side">
        <h2>Upgrade Options</h2>
        <div v-if="fw_response.upgrade_options != ''">
          <ul class="multi-box-list" id="firmware-select">
            <li class="img-bullet" v-for="(fw_option, index) in fw_response.upgrade_options" v-bind:key="fw_option.name">
              <div class="box">
                <h3>{{fw_option.name}}</h3>
                <div class="fw-label">
                <span v-if="index == 0">Recommended</span>
                <span v-else>Alternative</span>
                </div>
                <ul>
                  <li v-if="fw_option.transmitter_firmware_link && !fw_option.firmware_bundle_link">
                    <a :href="fw_option.transmitter_firmware_link">Transmitter Firmware</a>
                  </li>
                  <li v-if="fw_option.charger_firmware_link && !fw_option.firmware_bundle_link">
                    <a :href="fw_option.charger_firmware_link">Charger Firmware</a>
                  </li>
                  <li v-if="fw_option.web_firmware_link && !fw_option.firmware_bundle_link">
                    <a :href="fw_option.web_firmware_link">Web Firmware</a>
                  </li>
                  <li v-if="fw_option.firmware_bundle_link">
                    <a :href="fw_option.firmware_bundle_link">Firmware Bundle</a>
                  </li>
                  <li v-if="fw_option.doc_link">
                    <a :href="fw_option.doc_link">Documentation</a>
                  </li>
                  <li v-if="fw_option.api_link">
                    <a :href="fw_option.api_link">API Files</a>
                  </li>
                  <li v-if="fw_option.changelog_link">
                    <a :href="fw_option.changelog_link">Changelog</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div v-else>
          <div class="box">System Up to Date</div>
        </div>
      </div>
    </div>
    <div v-else-if="fw_response_error">{{fw_response_error}}</div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'UpdateInfo',
  props: {
    fw_commit_hash: String,
    hardware_type: String
  },
  data () {
    return {
      fw_response: null,
      fw_response_error: null
    }
  },
  mounted: function () {
    axios
      .get(
        'https://api.update.wibotic.com/check',
        {
          params: {
            ver: this.fw_commit_hash,
            hw: this.hardware_type
          }
        }
      )
      .then(response => {
        this.fw_response = response.data
      })
      .catch(error => {
        this.fw_response_error = error
      })
  }
}
</script>

<style>
.box {
  border: 2px solid #eee;
  width: 15em;
  margin: 1em;
  padding: 1em;
  position: relative;
}

.between-box {
  margin-top: 4em;
  width: 3em;
  height: 3em;
  display: flex;
  align-items: center;
  justify-content: center;
}

h3 {
  margin-top: 0;
  font-size: 1.15em;
}

h2 {
  margin-top: 0;
  font-size: 1.2em;
}

a {
  color: #1b9cde;
}

.fw_update_overall {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.multi-box-list {
  list-style: none;
  padding-left: 0;
}

.fw-label {
  font-size: .8em;
  float:right;
  position: absolute;
  top: 1em;
  right: 1em;
}

.info-blurb {
  border-top: 2px solid #eee;
  border-bottom: 2px solid #eee;
  padding: 1em;
}

.img-bullet ul {
  list-style:none;
  padding-left: 1em;
}
.img-bullet li:before {
  content: '';
  display: inline-block;
  height: 1em;
  width: 1em;
  background-image: url(../assets/download.svg);
  background-size: contain;
  background-repeat: no-repeat;
  margin-right:0.5em;
}
</style>
